var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Refresh"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/action/autorenew_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99992 6.49154V4.99987C7.24159 4.99987 4.99992 7.24154 4.99992 9.99987C4.99992 10.6582 5.12492 11.2999 5.36659 11.8749C5.49159 12.1749 5.39992 12.5165 5.17492 12.7415C4.74992 13.1665 4.03325 13.0165 3.80825 12.4582C3.49992 11.6999 3.33325 10.8665 3.33325 9.99987C3.33325 6.31654 6.31659 3.3332 9.99992 3.3332V1.84154C9.99992 1.46654 10.4499 1.2832 10.7083 1.54154L13.0333 3.86654C13.1999 4.0332 13.1999 4.29154 13.0333 4.4582L10.7083 6.7832C10.4499 7.04987 9.99992 6.86654 9.99992 6.49154ZM14.6333 8.12488C14.5083 7.83322 14.6 7.48322 14.825 7.25822C15.25 6.83322 15.9666 6.98322 16.1916 7.54155C16.5 8.29988 16.6666 9.13322 16.6666 9.99988C16.6666 13.6832 13.6833 16.6665 9.99997 16.6665V18.1665C9.99997 18.5332 9.54997 18.7165 9.29163 18.4582L6.96663 16.1332C6.79997 15.9665 6.79997 15.7082 6.96663 15.5415L9.29163 13.2165C9.54997 12.9499 9.99997 13.1332 9.99997 13.5082V14.9999C12.7583 14.9999 15 12.7582 15 9.99988C15 9.34155 14.8666 8.70822 14.6333 8.12488Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRefresh);
export default __webpack_public_path__ + "static/media/ic_refresh.56894ebec45ba2550c5a0668c783befc.svg";
export { ForwardRef as ReactComponent };